import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'

const PriceWithSeparateCents = ({ priceSeparateCents, perHourClass }) => (
  <>
    <span>{ReactHtmlParser(priceSeparateCents)}</span>
    <span className={perHourClass}>{I18n.t('courses.show.per_hour')}</span>
  </>
)

PriceWithSeparateCents.propTypes = {
  priceSeparateCents: PropTypes.string,
  perHourClass: PropTypes.string
}

export default PriceWithSeparateCents
